'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _omit = require('lodash/omit');

var _omit2 = _interopRequireDefault(_omit);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _debounce = require('lodash/debounce');

var _debounce2 = _interopRequireDefault(_debounce);

var _pages = require('../../api/pages');

var _client = require('../../utils/client');

var _inputField = require('constructicon/input-field');

var _inputField2 = _interopRequireDefault(_inputField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InputSlug = function (_Component) {
  _inherits(InputSlug, _Component);

  function InputSlug() {
    _classCallCheck(this, InputSlug);

    var _this = _possibleConstructorReturn(this, (InputSlug.__proto__ || Object.getPrototypeOf(InputSlug)).call(this));

    _this.fetchPageSlug = (0, _debounce2.default)(_this.fetchPageSlug.bind(_this), 500);
    _this.state = {
      status: 'fetched',
      slug: null,
      validations: []
    };
    return _this;
  }

  _createClass(InputSlug, [{
    key: 'fetchPageSlug',
    value: function fetchPageSlug(slug) {
      var _this2 = this;

      this.setState({
        slug: slug,
        validations: [],
        status: slug ? 'fetching' : 'fetched'
      });

      if (slug) {
        var _props = this.props,
            campaignSlug = _props.campaignSlug,
            countryCode = _props.countryCode;

        this.props.onBlur && this.props.onBlur(slug);

        (0, _pages.fetchPage)((0, _client.isJustGiving)() ? slug : { campaignSlug: campaignSlug, countryCode: countryCode, slug: slug }).then(function () {
          _this2.props.handleFetch(false);
          _this2.setState({
            validations: ['The URL \'' + slug + '\' is not available. Please try a different value.'],
            status: 'failed'
          });
        }).catch(function (_ref) {
          var status = _ref.status;

          if (status === 404) {
            _this2.setState({ validations: [], status: 'fetched' });
            _this2.props.handleFetch(true);
          }
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _state = this.state,
          status = _state.status,
          slug = _state.slug;

      var _props2 = this.props,
          _props2$validations = _props2.validations,
          validations = _props2$validations === undefined ? [] : _props2$validations,
          touched = _props2.touched,
          props = _objectWithoutProperties(_props2, ['validations', 'touched']);

      var errors = validations.concat(this.state.validations);

      return _react2.default.createElement(_inputField2.default, _extends({}, (0, _omit2.default)(props, ['handleFetch']), {
        type: 'search',
        autoComplete: 'off',
        status: slug && status,
        onKeyUp: function onKeyUp(e) {
          return _this3.fetchPageSlug(e.target.value);
        },
        error: touched && !!errors.length,
        invalid: !!errors.length,
        validations: errors
      }));
    }
  }]);

  return InputSlug;
}(_react.Component);

InputSlug.propTypes = {
  /**
   * The campaign slug for the page slug lookup (EDH only - required)
   */
  campaignSlug: _propTypes2.default.string,

  /**
   * Country for the page slug lookup (EDH only - required)
   */
  countryCode: _propTypes2.default.oneOf(['au', 'nz', 'uk', 'us', 'ie']),

  /**
   * The change handler
   */
  handleFetch: _propTypes2.default.func.isRequired
};

exports.default = InputSlug;


//////////////////
// WEBPACK FOOTER
// ../~/supporticon/components/input-slug/index.js
// module id = 1342
// module chunks = 0